import { call, put } from 'redux-saga/effects';

import {
  axiosAuthInstance,
  API_END_POINTS,
} from 'api';

import {
  CASH_RECEIPTS,
  LOADING,
} from '../actionTypes';

const fetchCashReceipts = async gid => axiosAuthInstance.get(`${API_END_POINTS.CASH_RECEIPTS}/${gid}`);

export function* getCashReceipts(action) {
  try {
    yield put({ type: LOADING.SET });
    const { data: { entity } } = yield call(fetchCashReceipts, action.payload);
    yield put({ type: CASH_RECEIPTS.SUCCESS, payload: entity });
  } catch (e) {
    yield put({ type: CASH_RECEIPTS.FAILED, payload: e.response.data });
  } finally {
    yield put({ type: LOADING.UNSET });
  }
}
